import { createEntityAdapter } from '@reduxjs/toolkit'
import { IStorage } from '../../types/storage'

export const storagesAdapter = createEntityAdapter<IStorage>()